import { HStack, Stack, StackProps, useBreakpointValue } from '@chakra-ui/react'
import { START_SURVEY_FIXED_FOOTER_HEIGHT_IN_PX } from 'components/modules/landings/prep/common/StartSurveyFixedFooter'
import { FC, ReactNode, useCallback, useEffect, useState } from 'react'

interface StickyFooterProps extends StackProps {
  alwaysVisible?: boolean
  children: ReactNode
}

export const StickyFooter: FC<StickyFooterProps> = ({ children, alwaysVisible, ...rest }) => {
  const [isVisible, setIsVisible] = useState(alwaysVisible)

  const isMobile = useBreakpointValue({ base: true, lg: false })

  const handleScroll = useCallback(() => {
    if (alwaysVisible) return
    const currentScrollPos = window.scrollY
    const visible = currentScrollPos > 0

    setIsVisible(visible)
  }, [alwaysVisible])

  useEffect(() => {
    if (alwaysVisible) return
    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [alwaysVisible, handleScroll])

  if (!isMobile) return null

  return (
    <Stack
      spacing={0}
      bottom={isVisible ? 0 : '-264px'}
      transition="bottom 750ms ease-out"
      zIndex="10000"
      w="100vw"
      position="fixed"
      pointerEvents="none"
    >
      <HStack
        bg="grayscale.20"
        w="100vw"
        px={6}
        py={3}
        spacing="16px"
        transition="bottom 750ms ease-out"
        justifyContent="space-between"
        h={START_SURVEY_FIXED_FOOTER_HEIGHT_IN_PX}
        pointerEvents="auto"
        {...rest}
      >
        {children}
      </HStack>
    </Stack>
  )
}
